export const SEND_COMMAND_OPEN_MODAL = "SEND_COMMAND_OPEN_MODAL";
export const SEND_COMMAND_CLOSE_MODAL = "SEND_COMMAND_CLOSE_MODAL";

export const SEND_COMMAND_GET_DEVICE_REQUEST = "SEND_COMMAND_GET_DEVICE_REQUEST";
export const SEND_COMMAND_GET_DEVICE_RESULT = "SEND_COMMAND_GET_DEVICE_RESULT";

export const SEND_COMMAND_REQUEST = "SEND_COMMAND_REQUEST";
export const SEND_COMMAND_RESULT = "SEND_COMMAND_RESULT";

export const SEND_COMMAND_SET_DEVICES = "SEND_COMMAND_SET_DEVICES";

export const SEND_COMMAND_SEARCH_DEVICE_MODEL_REQUEST = "SEND_COMMAND_SEARCH_DEVICE_MODEL_REQUEST";
export const SEND_COMMAND_SEARCH_DEVICE_MODEL_RESULT = "SEND_COMMAND_SEARCH_DEVICE_MODEL_RESULT";

export const SEND_COMMAND_SEARCH_COMMANDS_REQUEST = "SEND_COMMAND_SEARCH_COMMANDS_REQUEST";
export const SEND_COMMAND_SEARCH_COMMANDS_RESULT = "SEND_COMMAND_SEARCH_COMMANDS_RESULT";
export const SEND_COMMAND_SEARCH_MASS_COMMANDS_REQUEST = "SEND_COMMAND_SEARCH_MASS_COMMANDS_REQUEST";
export const SEND_COMMAND_SEARCH_MASS_COMMANDS_RESULT = "SEND_COMMAND_SEARCH_MASS_COMMANDS_RESULT";


export const SEND_COMMAND_GET_DETAILS_REQUEST = "SEND_COMMAND_GET_DETAILS_REQUEST";
export const SEND_COMMAND_GET_DETAILS_RESULT = "SEND_COMMAND_GET_DETAILS_RESULT";

export const SEND_COMMAND_GENERAL_REQUEST = "SEND_COMMAND_GENERAL_REQUEST";
